"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductInfo = ({
  name,
  code
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(`${_constants.PRODUCT_INFO}-${code}`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
      className: _constants.productInfoNameClassName,
      color: "textPrimary",
      fontWeight: "bold",
      children: name
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "caption",
      color: "textSecondary",
      children: code
    })]
  });
};
exports.ProductInfo = ProductInfo;
//# sourceMappingURL=ProductInfo.js.map